import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import Footer from "../Footer";
import Sidebar from "../sidebar";
import Topnav from "../TopNav";
import { API_URL } from "../config";
import Swal from 'sweetalert2';
import { ClipLoader } from 'react-spinners';
// import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';
// import { getCurrentDate } from '../Components/DateFunction';

const Sermons = () => {
    const [sermons, setSermons] = useState([]);
    const [filteredSermons, setFilteredSermons] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [currentGroupId, setCurrentGroupId] = useState(null);
    const [formData, setFormData] = useState({ id: '', name: '', weblink: '', date: '' });
    const [searchTerm, setSearchTerm] = useState('');
    // const [sortField, setSortField] = useState('Name');
    // const [sortOrder, setSortOrder] = useState('asc');
    const [show, setShow] = useState(false);

    const toggleSidebar = () => {
        setShow(prevShow => !prevShow); // Toggle the show state
    };

    const fetchSermons = async () => {
        try {
            const response = await fetch(`${API_URL}/sermons`);
            if (!response.ok) throw new Error('Failed to fetch Sermons');
            const data = await response.json();
            setSermons(data);
            setFilteredSermons(data);
        } catch (error) {
            console.error(error);
            alert('Error fetching Sermons: ' + error.message);
        }
    };

    useEffect(() => {
        fetchSermons();
    }, []);

    useEffect(() => {
        const filtered = sermons.filter(sermon =>
            (sermon.name ? sermon.name.toLowerCase() : '').includes(searchTerm.toLowerCase())
        );
        setFilteredSermons(filtered);
    }, [searchTerm, sermons]);

    const handleAddGroup = () => {
        setFormData({ name: '', weblink: '', date: '' });
        setShowAddModal(true);
    };

    const handleEditGroup = (sermon) => {
        setFormData(sermon);
        setCurrentGroupId(sermon.id);
        setShowEditModal(true);
    };

    // const handleDeleteGroup = async (id) => {
    //     if (window.confirm("Are you sure you want to delete this group?")) {
    //         await fetch(`${API_URL}/sermons/${id}`, { method: 'DELETE' });
    //         fetchSermons();
    //     }
    // };

    // const handleSubmitAdd = async (e) => {
    //     e.preventDefault();

    //     // Add the sermon   
    //     await fetch(`${API_URL}/sermons`, {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify(formData),
    //     });

    //     fetchSermons();
    //     setShowAddModal(false);

    // };

    // const handleSubmitEdit = async (e) => {
    //     e.preventDefault();
    //     console.log("Updating group with ID:", currentGroupId);
    //     console.log("Form Data:", formData); // Log form data

    //     try {
    //         const response = await fetch(`${API_URL}/sermons/${formData.id}`, {
    //             method: 'PUT',
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify(formData),
    //         });

    //         if (!response.ok) {
    //             const errorText = await response.text(); // Get error text for better debugging
    //             throw new Error(`Failed to update the Sermon: ${errorText}`);
    //         }

    //         fetchSermons();
    //         setShowEditModal(false);
    //     } catch (error) {
    //         console.error(error);
    //         alert('Error updating Sermon: ' + error.message);
    //     }
    // };

    const handleDeleteGroup = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });

        if (result.isConfirmed) {
            try {
                await fetch(`${API_URL}/sermons/${id}`, { method: 'DELETE' });
                fetchSermons(); // Refresh the sermon list

                Swal.fire({
                    text: "Group successfully deleted",
                    icon: "success"
                });
            } catch (error) {
                console.error("Error deleting group:", error);
                Swal.fire({
                    text: "Failed to delete group",
                    icon: "error"
                });
            }
        } else {
            Swal.fire({
                text: "Deletion canceled",
                icon: "info"
            });
        }
    };

    const handleSubmitAdd = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            // Add the sermon   
            await fetch(`${API_URL}/sermons`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            fetchSermons(); // Refresh the sermon list
            setShowAddModal(false);
            setIsLoading(false);

            Swal.fire({
                text: "Sermon successfully added",
                icon: "success"
            });
        } catch (error) {
            console.error("Error adding sermon:", error);
            Swal.fire({
                text: "Failed to add sermon",
                icon: "error"
            });
            setIsLoading(false);
        }
    };

    const handleSubmitEdit = async (e) => {
        e.preventDefault();
        console.log("Updating group with ID:", currentGroupId);
        console.log("Form Data:", formData); // Log form data

        try {
            const response = await fetch(`${API_URL}/sermons/${formData.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                const errorText = await response.text(); // Get error text for better debugging
                throw new Error(`Failed to update the Sermon: ${errorText}`);
            }

            fetchSermons(); // Refresh the sermon list
            setShowEditModal(false);

            Swal.fire({
                text: "Sermon successfully updated",
                icon: "success"
            });
        } catch (error) {
            console.error(error);
            Swal.fire({
                text: "Error updating sermon: " + error.message,
                icon: "error"
            });
        }
    };


    return (
        <div>
            <div className="wrapper">
                <Sidebar show={show} />
                <div className="main-panel">
                    <Topnav toggleSidebar={toggleSidebar} />
                    <div className="container">
                        <div className="page-inner">
                            <div className="d-flex justify-content-between align-items-center pt-2 pb-4">
                                <h2 className="text-capitalize font-weight-bold">
                                    Sermons ({filteredSermons.length})
                                </h2>
                                <div>
                                    <button className="btn btn-sm" onClick={handleAddGroup} style={{ backgroundColor: 'rgb(20,24,40)', color: '#ffffff' }}>
                                        <FontAwesomeIcon icon={faPlus} /> Add Sermon
                                    </button>
                                </div>
                            </div>

                            <div className="form-group mb-4">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by name"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Link</th>
                                            <th>Date</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredSermons.map((sermon) => (
                                            <tr key={sermon.id}>
                                                <td>{sermon.name}</td>
                                                <td>{sermon.weblink}</td>
                                                <td>{sermon.date.slice(0, 10)}</td>
                                                <td>
                                                    <button onClick={() => handleEditGroup(sermon)} className="btn btn-link">
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </button>
                                                    <button onClick={() => handleDeleteGroup(sermon.id)} className="btn btn-link">
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <footer className="footer">
                        <Footer />
                    </footer>
                </div>
            </div>

            {/* Add Sermon Modal */}
            {showAddModal && (
                <div className="modal fade show" style={{ display: 'block' }} onClick={() => setShowAddModal(false)}>
                    <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Add Sermon</h5>
                                <button type="button" className="close" onClick={() => setShowAddModal(false)}>&times;</button>
                            </div>
                            <form onSubmit={handleSubmitAdd}>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <label className="modal-label">Name</label>
                                        <input type="text" className="form-control" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
                                    </div>
                                    <div className="form-group">
                                        <label className="modal-label">Link</label>
                                        <input type="text" className="form-control" value={formData.weblink} onChange={(e) => setFormData({ ...formData, weblink: e.target.value })} required />
                                    </div>
                                    <div className="form-group">
                                        <label className="modal-label">Date</label>
                                        <input type='date' className="form-control" value={formData.date} onChange={(e) => setFormData({ ...formData, date: e.target.value })} required />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowAddModal(false)}>Close</button>
                                    {isLoading && (
                                        <div style={{ marginTop: '8px', textAlign: 'center', width: '45px' }}>
                                            <ClipLoader loading={isLoading} size={35} color="blue" />
                                        </div>
                                    )}
                                    {!isLoading && (
                                        <button type="submit" className="btn btn-primary">Add Sermon</button>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Sermon Modal */}
            {showEditModal && (
                <div className="modal fade show" style={{ display: 'block' }} onClick={() => setShowEditModal(false)}>
                    <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Sermon</h5>
                                <button type="button" className="close" onClick={() => setShowEditModal(false)}>&times;</button>
                            </div>
                            <form onSubmit={handleSubmitEdit}>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <label className="modal-label">Name</label>
                                        <input type="text" className="form-control" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
                                    </div>
                                    <div className="form-group">
                                        <label className="modal-label">Link</label>
                                        <input type="text" className="form-control" value={formData.weblink} onChange={(e) => setFormData({ ...formData, weblink: e.target.value })} required />
                                    </div>
                                    <div className="form-group">
                                        <label className="modal-label">Date</label>
                                        <input type='date' className="form-control" value={formData.date.slice(0, 10)} onChange={(e) => setFormData({ ...formData, date: e.target.value })} required />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Close</button>
                                    <button type="submit" className="btn btn-primary">Update Sermon</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Sermons;
